export default __webpack_public_path__ + "static/Roboto-Black-cf56c1b149d0a5e8d7c6503cd98b56a3.ttf";